import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=2f19ad81&"
import script from "./Footer.vue?vue&type=script&lang=js&"
export * from "./Footer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ContactForm: require('/private/var/folders/c0/mk3zh23n40nd2cwxybf80c0h0000gn/T/ltng/components/ContactForm.vue').default,Footer: require('/private/var/folders/c0/mk3zh23n40nd2cwxybf80c0h0000gn/T/ltng/components/Footer.vue').default})
